module.exports = __webpack_public_path__ + "static/first_explain_en.6a0d7b04.png";